// TODO: copied from app/assets/javascripts/components/WebsiteOnboarding/Spinner.jsx
// after refactoring FullCalendar please remove that component from above path and move to common components
import React from 'react';
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';

const useStyles = makeStyles({
  spinner: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 100,
    bottom: 100,
    opacity: 0.8,
    backgroundColor: 'white',
    zIndex: 99,
  },
});

const Spinner = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Grid container justify="center" alignItems="center" color="accent" className={classes.spinner}>
      <CircularProgress />
    </Grid>
  );
};

export default Spinner;
